<ng-template #seExternalDocsDialogTemplate>
    <form class="se-flex se-expand" (ngSubmit)="closeModal()">
        <div class="external-docs-form-content">
            <div class="se-dialog-header se-flex mat-elevation-z6" [class.se-dialog-header-error]="isOnError">
                <div class="se-expand"></div>
                <h1 class="mat-h1 se-external-docs-title"><span translate>AttachedDocuments</span></h1>
                <div class="se-expand"></div>
                <button class="close-button" matSuffix mat-icon-button type="button" tabIndex="-1"
                        (click)='closeModal()'
                        [disabled]='isCloseButtonDisabled'>
                    <mat-icon fontSet="estensa-icons">icon_cross</mat-icon>
                </button>
            </div>

            <div class="se-external-docs-dialog-main-container"
                 *ngIf="(isWaiting | async) === false">

                <div class="se-external-docs-dialog-container">

                    <div>
                        <!--tree-->
                        <div class="se-external-docs-document-tree-container">
                            <se-external-docs-tree [externalDocuments]="externalDocuments"
                                                   [isLoadingDoc]="isLoadingDoc"
                                                   (deleteRequired)="onDeleteRequired($event)"
                                                   (editRequired)="onEditRequired($event)"
                                                   (addRequired)="onAddRequired($event)">
                            </se-external-docs-tree>
                        </div>

                        <!--Preview-->
                        <div class="se-external-docs-document-preview-container">

                            <!-- Messaggi -->
                            <div *ngIf="!_selectedDoc">
                                <div class="se-expand"></div>
                                <span class="mat-h3;" style="align-self: center;">{{ getEmptyMessage() }}</span>
                                <div class="se-expand"></div>
                            </div>

                            <!-- Spinner -->
                            <div *ngIf="_selectedDoc && isLoadingDoc" class="estensa-spinner">
                                <mat-spinner></mat-spinner>
                            </div>

                            <!-- visualizzatore PDF -->
                            <div class="se-external-docs-pdf-viewer-main-container" *ngIf="canShowPdfViewer()">
                                <div class="se-external-docs-pdf-viewer-header" #test>
                                    <div class="buttons-center">
                                        <button mat-button
                                                type="button"
                                                (click)="zoomOut()">
                                            <mat-icon aria-label="Zoom out">zoom_out</mat-icon>
                                        </button>
                                        <span class="buttons-zoom">
                                            {{ zoomPdf * 100 | number }} %
                                        </span>
                                        <button mat-button
                                                type="button"
                                                (click)="zoomIn()">
                                            <mat-icon aria-label="Zoom in">zoom_in</mat-icon>
                                        </button>
                                    </div>
                                </div>

                                <div class="se-external-docs-pdf-viewer-container">

                                    <pdf-viewer class="se-external-docs-pdf-viewer"
                                                [fit-to-page]="true"
                                                [original-size]="true"
                                                [show-all]="true"
                                                [src]="pdfSource"
                                                [zoom]="zoomPdf">
                                    </pdf-viewer>
                                </div>
                            </div>

                            <!-- visualizzatore IMG -->
                            <div class="se-external-docs-pdf-viewer-main-container" *ngIf="canShowImageViewer()">
                                <div class="se-external-docs-pdf-viewer-header">
                                    <div class="buttons-center">
                                        <button mat-button
                                                type="button"
                                                (click)="zoomImgOut()">
                                            <mat-icon aria-label="Zoom out">zoom_out</mat-icon>
                                        </button>
                                        <span class="buttons-zoom">
                                            {{ zoomImg | number }} %
                                        </span>
                                        <button mat-button
                                                type="button"
                                                (click)="zoomImgIn()">
                                            <mat-icon aria-label="Zoom in">zoom_in</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div style="overflow:auto;flex:1" #imageContainer>
                                    <img #imageDocViewer [src]="imageSource"
                                         style="width:100%;height: auto;object-fit:contain;"
                                         alt="image" [ngStyle]="{'width' : zoomImg + '%' }" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="isAddingDoc || isEditingDoc" class="se-external-docs-popup-panel">
                        <se-external-docs-editor [isAddingDoc]="isAddingDoc"
                                                 [isEditingDoc]="isEditingDoc"
                                                 [selectedDoc]="_selectedDoc"
                                                 [selectedDocType]="_selectedDocType"
                                                 (cancelOpsRequired)="cancelOps($event)"
                                                 (confirmOpsRequired)="confirmOps($event)">
                        </se-external-docs-editor>
                    </div>

                    <!-- Messaggio errore && conferma rimozione-->
                    <div *ngIf="isOnError || isDeletingDoc || isConfirmedOp" class="se-external-docs-popup-panel">
                        <se-external-docs-message [isOnError]="isOnError"
                                                  [isDeletingDoc]="isDeletingDoc"
                                                  [isConfirmedOp]="isConfirmedOp"
                                                  [messageBoxText]="messageBoxText"
                                                  (cancelOpsRequired)="cancelOps($event)"
                                                  (confirmOpsRequired)="confirmOps($event)">
                        </se-external-docs-message>
                    </div>
                </div>

                <!-- Pulsanti finestra principale -->
                <div class="se-external-docs-dialog-action-container">
                    <button mat-button
                            [disabled]='isCloseButtonDisabled'
                            color="primary"
                            type="button"
                            (click)="closeModal()">
                        <p translate>Close</p>
                    </button>

                    <button type="submit" [disabled]="!isCloseButtonDisabled" style="display:none">hidden submit
                    </button>
                </div>
            </div>
        </div>
    </form>

    <div class="estensa-spinner se-external-docs-spinner" *ngIf="(isOnServerOp | async) || (isWaiting | async)">
        <mat-spinner diameter="96" color="accent"></mat-spinner>
    </div>
</ng-template>
